/*
 * @Author: Latte
 * @Date: 2021-11-18 17:01:53
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-25 15:58:46
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\role.js
 */
import request from "@/utils/request";
import config from "@/utils/config";
import qs from "qs";

/**
 * @description: 角色绑定权限
 * @param {*} data
 * @return {*}
 */
export function roleBindPermission(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/bind/roleBindPermission",
		method: 'post',
		data,
	})
}

/**
 * @description: 用户绑定角色（解绑，修改绑定都是用这个接口）
 * @param {*} params
 * @return {*}
 */
export function userBindRole(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/bind/userBindRole",
		method: "post",
		params,
		paramsSerializer: (params) => {
			const { userID, roleIDArray } = params;
			const formatArray = qs.stringify(
				{ userID, roleIDArray },
				{indices: false}
			);
			return formatArray;
		},
	});
}

/**
 * @description: 查询用户绑定的角色
 * @param {*} params
 * @return {*}
 */
export function getUserRole(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/userRole",
		method: "get",
		params,
	});
}

/**
 * 获取所有角色列表
 *
 * @param {*} params
 */
export function getRoleList(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/role/list",
		method: "get",
		params,
	});
}

/**
 * 获取单个角色详情
 *
 * @param {*} params
 */
export function getRole(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/role",
		method: "get",
		params,
	});
}

/**
 * 添加角色
 *
 * @param {*} data
 */
export function addRole(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/role",
		method: "post",
		data,
	});
}

/**
 * 编辑角色
 *
 * @param {*} data
 */
export function editRole(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/role",
		method: "put",
		data,
	});
}

/**
 * 删除角色
 *
 * @param {*} params
 */
export function deleteRole(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/role",
		method: "delete",
		params,
	});
}

/**
 * @description: 获取角色绑定的权限
 * @param {*} params
 * @return {*}
 */
export function getRoleBindPermissions(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/rolePermission",
		method: "get",
		params
	})
}
